import React, { useState, useEffect, useCallback } from "react"
import AdminResourcesEventsApi from "../../services/adminResourcesEvents";
import NetworkApi from "../../services/networks";
import EventsTable from "../../tables/EventsTable"
import DashboardHeader from '../../components/DashboardHeader';
import { PopupboxContainer } from 'react-popupbox';
import LetterFilter from "../../components/LetterFilter";
import Pagination from "../../components/Pagination"

function EventsPage(props) {
    const [events, setEvents] = useState([]);
    const [search, setSearch] = useState('');
    const [searchCity, setSearchCity] = useState('');
    const [searchStatus, setSearchStatus] = useState('All');
    const [selectedNetwork, setSelectedNetwork] = useState('');
    const [networks, setNetworks] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [pageItemActive, setPageItemActive] = useState(1);
    const [activeLetter, setActiveLetter] = useState('all'); 

    const fetch = useCallback(async() => {
        const eventsApi = new AdminResourcesEventsApi(props.token);
        try {
            if (selectedNetwork && selectedNetwork !== '') {
                let response = await eventsApi.searchByNetwork(selectedNetwork, searchStatus, pageItemActive);
                setEvents(response.events);
                setTotalPages(response.total_pages);
            }
            else if(search && searchCity ){
                let response = await eventsApi.searchByCity(searchCity, searchStatus, pageItemActive)
                let filteredData = response.events.filter((event) => event.title.toLowerCase().includes(search.toLowerCase()))
                setEvents([...filteredData]);
                setTotalPages(response.total_pages);
            }
            else if (searchCity ) {
                let response = await eventsApi.searchByCity(searchCity, searchStatus, pageItemActive)
                setEvents(response.events);
                setTotalPages(response.total_pages);
            }
            else if (activeLetter && activeLetter !== 'all') {
                let response = await eventsApi.filterByLetter(searchStatus, activeLetter, pageItemActive);
                setEvents(response.events);
                setTotalPages(response.total_pages);
            }   
            else if (search) {
                let response = await eventsApi.search(search, searchStatus, pageItemActive)
                setEvents(response.events);
                setTotalPages(response.total_pages);
            }
            else{
                let response = await eventsApi.all(searchStatus, pageItemActive)
                setEvents(response.events);
                setTotalPages(response.total_pages);
                if(!search && !searchCity){
                    setActiveLetter('all');
                }
            }
        } catch (error) {
            console.error(error);
            setEvents([]);
        }
    }, [selectedNetwork, search, searchCity, searchStatus, activeLetter, pageItemActive, props.token])

    useEffect(()=>{
        fetch()
    },[fetch])

    const fetchNetworks = useCallback(async () => {
        const networkApi = new NetworkApi(props.token);
        try {
            const response = await networkApi.all("Published", 1);
            setNetworks(response.networks || []);
        } catch (error) {
            console.error('Error fetching networks:', error);
            setNetworks([]);
        }
    }, [props.token]);

    useEffect(() => {
        fetchNetworks();
    }, [fetchNetworks]);


    const __handleSearch = (event) => {
        setSearch(event.target.value);
        setActiveLetter('');
        setSelectedNetwork('');
    };

    const handleSearchByCity =(event)=>{
        let value = event.target.value;
        setSearchCity(value);
        setActiveLetter('');
        setSelectedNetwork('');
    }

    const handleSearchByStatus =(event)=>{
        let value = event.target.value;
        setSearchStatus(value);
    }

    const handleNetworkChange = (event) => {
        setSelectedNetwork(event.target.value);
        setSearch('');
        setSearchCity('');
        setActiveLetter('');
    }
  
    const handleLetterClick = (letter) => {
        setSearch('')
        setSearchCity('')
        setSelectedNetwork('')
        setPageItemActive(1); 
        if(letter === 'all'){
            setActiveLetter('all'); 
        }else{
            setActiveLetter(letter); 
        }
      };

    const handleSelectPage=(pageNumber)=>{
        setPageItemActive(pageNumber);
    }
    
    return (
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="New Event" link='/event/new' />
            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Events</h2>
                    <div>
                        <div className='dashboard-content-search mx-2'>
                            <select                                
                                value={searchStatus}                                
                                className='dashboard-content-input search-status-input'
                                onChange={e => handleSearchByStatus(e)} >                                
                                <option value="All">All</option>    
                                <option value="Published">Published</option>    
                                <option value="Unpublished">Unpublished</option>
                            </select>
                        </div>
                        <div className='dashboard-content-search'>
                            <input
                                type='text'
                                value={search}
                                placeholder='Search by title..'
                                className='dashboard-content-input'
                                onChange={e => __handleSearch(e)} />
                        </div>
                        <div className='dashboard-content-search search-city-input'>
                            <input
                                type='text'
                                value={searchCity}
                                placeholder='Search by city..'
                                className='dashboard-content-input'
                                onChange={e => handleSearchByCity(e)} />
                        </div>
                        <div className='dashboard-content-search search-city-input'>
                            <select
                                value={selectedNetwork}
                                className='dashboard-content-input'
                                onChange={e => handleNetworkChange(e)}>
                                <option value=''>Filter by Network</option>
                                {networks.map((network) => (
                                    <option key={network.id} value={network.id}>
                                        {network.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <LetterFilter activeLetter={activeLetter} onLetterClick={handleLetterClick}/>
                <div className="organizations-custom-popup">
                    <PopupboxContainer />
                </div>
                    {
                        events.length > 0 ?
                            <EventsTable events={events} {...props} refresh={fetch} />
                            :
                            <div className='dashboard-content-footer'>
                                <span className='empty-table'>No data</span>
                            </div>
                    }
                <Pagination totalPages={totalPages} pageItemActive={pageItemActive} handleSelectItem={handleSelectPage}/>
            </div>
        </div>
    )
}

export default EventsPage
